"use strict";

var processInclude = require("purina_core/util");

$(document).ready(function () {
    processInclude(require("./search/search"));
    processInclude(require("purina_core/product/quickView"));
});
